const throttle = require('../lib/throttle')
const {bind} = require('../lib/bind')

class Embed {
  constructor(element, params) {
    this.resize = this.resize.bind(this);
    this.element = element;
    this.params = params;
    this.container = this.element.parentNode;
    this.deckEmbed = this.element.closest('.deck-embed[data-state=processed]')
    this.deck = this.element.closest('.deck')
    this.id = this.element.getAttribute('data-id');
    this.deckName = this.element.getAttribute('data-name');
    this.ratio = this.element.getAttribute('data-ratio') || (4/3);
    if (this.params == null) { this.params = {}; }
    this.params.slide = this.element.getAttribute('data-slide') || this.slideFromHash();
    this.params.type = this.element.getAttribute('data-type');
    this.params.title = this.element.getAttribute('data-title');
    this.params.skipResize = this.element.getAttribute('data-skip-resize');

    // default host to speakerdeck.com
    this.host = "speakerdeck.com";

    // if there is a src tag, like when embedded on external site, try to derive
    // the host from that
    const src = this.element.getAttribute('src');
    if (src) {
      this.host = src.replace(/.*\/\/(.*?)\/.*/, '$1');
    }

    // if there is a data-host attribute, like when embedded on speakerdeck in
    // dev, production, etc. then use that as host
    const dataHost = this.element.getAttribute('data-host');
    if (dataHost) {
      this.host = dataHost;
    }

    this.setup();
  }

  url() {
    const protocol = window.location.protocol;
    return `${protocol}//${this.host}/player/${this.id}?${this.toParam()}`;
  }

  toParam() {
    return ((() => {
      const result = [];
      for (let attr in this.params) {
        const value = this.params[attr];
        if (value && (value != 'slide' && String(value) != '1')) {
          result.push(`${attr}=${encodeURIComponent(value)}`);
        }
      }
      return result;
    })()).join('&');
  }

  setup() {
    this.createFrame();
    this.bindEvents();
    this.insert();
    this.resize();
  }

  // Create the iframe element, set basic styles and properties, and set the src
  createFrame() {
    this.iframe = document.createElement('iframe');
    this.iframe.className = 'speakerdeck-iframe';
    this.iframe.style.border = '0';
    this.iframe.style.background = 'rgba(0, 0, 0, 0.1)';
    this.iframe.style.margin = '0';
    this.iframe.style.padding = '0';
    this.iframe.border = 0;
    this.iframe.frameBorder = 0;
    this.iframe.allowTransparency = true;
    this.iframe.src = this.url();
    this.iframe.title = this.deckName;
    this.iframe.setAttribute('allowfullscreen', true);
    this.iframe.style['background-clip'] = 'padding-box';
    this.iframe.style['border-radius'] = '6px';
    this.iframe.style['box-shadow'] = 'rgba(0, 0, 0, 0.2) 0 5px 40px';

    this.iframe.emebed = this

    this.wrapper = document.createElement('div');
    this.wrapper.className = 'speakerdeck-embed-wrapper'
    this.wrapper.appendChild(this.iframe);
  }

  // Insert the iframe element into the page
  insert() {
    this.container.replaceChild(this.wrapper, this.element);
  }

  // Resize the iframe to fit in the parent container
  resize() {
    if (this.fullScreen) {
      return false;
    }

    if (this.deckEmbed && this.deck && this.ratio) {
      const height = this.deckEmbed.offsetHeight - 25
      const maxWidth = this.deck.offsetWidth - 40
      let width = Math.floor(height * parseFloat(this.ratio))
      if (width > maxWidth) {
        width = maxWidth
      }

      this.deckEmbed.style.width = width + 'px'
    }

    this.iframe.style.width = this.width() + 'px';
    this.iframe.style.height = this.height() + 'px';
  }

  // Get the width of the container
  width() {
    return this.wrapper.offsetWidth;
  }

  // Calculate the height based on the width of the container and the ratio
  height() {
    return Math.round(this.width() / this.ratio);
  }

  bindEvents() {
    bind(document, 'keydown', this.sendKeyDown.bind(this));
    bind(window, 'resize', throttle(this.resize, 100));

    bind(this.iframe, 'sd:embed:fullscreen:on', this.forceFullscreen.bind(this))
    bind(this.iframe, 'sd:embed:fullscreen:off', this.unforceFullscreen.bind(this))
  }

  sendKeyDown(e) {
    if (e.target.tagName.toLowerCase() == 'body') {
      this.iframe.contentWindow.postMessage({type: 'keydown', keyCode: e.keyCode}, '*')
    }
  }

  slideFromHash() {
    let match;
    if (match = window.location.hash.match(/^#(\d+)$/)) { return Number(match[1]); }
  }

  forceFullscreen() {
    this.fullScreen = true
    this.iframe.style.position = 'fixed'
    this.iframe.style['border-radius'] = 0
    this.iframe.style.zIndex = 10000
    this.iframe.style.top = 0
    this.iframe.style.right = 0
    this.iframe.style.bottom = 0
    this.iframe.style.left = 0
    this.iframe.style.width = '100%'
    this.iframe.style.height = '100%'
  }

  unforceFullscreen() {
    this.fullScreen = false
    this.iframe.style['border-radius'] = '6px'
    this.iframe.style.position = 'static'
    this.iframe.style.top = 'auto'
    this.iframe.style.right = 'auto'
    this.iframe.style.bottom = 'auto'
    this.iframe.style.left = 'auto'
    this.resize()
  }
}

Embed.init = () => {
  const elements = document.querySelectorAll('.speakerdeck-embed');
  Array.from(elements).map((element) => new Embed(element));
}

module.exports = Embed
